export default __webpack_public_path__ + "static/media/ramp_young_kids.20a53f1d.jpg";